export default {
  settings: {
    title: '设置',
    account_related: '账号关联信息',
    user_related: '用户关联信息',
    add_user_title: '添加用户',
    edit_user_title: '编辑用户',
    label: {
      enabled: '有',
      not_set: '未设置',
    },
    company: {
      title: '公司信息',
      name: '公司名称',
      english_name: 'English name',
      scale: '员工人数',
      industry_type: '行业',
      plan: '计划',
      location: '地址',
      allowed_ip: 'IP地址限制',
      mfa: 'SMS短信⾝份认证',
      sales_amount: '销售额',
      country: '国家',
    },
    contract_plans: {
      buyer: '买方计划',
      supplier: '供应商计划',
    },
    user: {
      title: '用户一览',
      name: '姓名',
      first_name: '名',
      last_name: '姓',
      email: '电子邮件地址',
      email_unverified: '沟通前',
      password: '密码',
      password_protection: '为了确保安全性不予显示',
      phone_number: '电话号码',
      role: {
        title: '权限',
        admin: '管理员',
        general: '通用',
      },
      locale: '选择语言',
      action: '操作',
      total: '总计{total}件 (最大{max}件)',
    },
    button: {
      create: '添加用户',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【注意事项】',
    cautions_01: '无法更改电子邮件地址。如果要重新设置电子邮件，请重新创建用户。',
    cautions_02: '如果设置了短信验证，则电话号码是必填项。',
    cautions_03: '要重置您的密码，请在密码重置页面中输入发送到您所注册的电子邮件地址的确认码',
    cautions_04: '删除用户不会删除已答复的数据或得分卡。',
    messages: {
      user_update: '更新用户信息',
      user_delete: '删除用户',
      confirm_delete: '是否删除该用户？',
      complete_create: '用户信息已添加。',
      complete_update: '用户信息已更新。',
      complete_delete: '用户信息已删除。',
      disabled_delete: '由于管理员丢失，无法删除',
      disabled_delete_by_auth: '仅管理者可以删除',
      invalid_form: '输入内容不完整。',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: '点击“添加”，确认邮件将发送至您输入的电子邮件地址。\n然后您将收到一封包含您的登录ID及密码的电子邮件。',
      caution_two: '如果设置了短信验证，则电话号码是必填项。',
      caution_three: '最多可添加5名用户。',
      user_add_title: '@:settings.button.create',
      user_add_message_one: '确认邮件已发送到您的电子邮箱。',
      user_add_message_two: '请确认，并根据邮件内容登录。',
    },
    tips: {
      role: '“管理员”权限可以添加和删除用户，但“常规”权限不能。',
      locale: '您可以选择登录后默认显示的语言。',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: '您确定要退出并转到密码重置页面吗？请在密码重置页面中输入发送到您所注册的电子邮件地址的确认码。',
      reset: '重置',
    },
  },
}
